import { EditableTextProps } from './types';

export default function useEditableTextProps(
  name: string,
  onAction: EditableTextProps['onAction'],
  setNewName: (name: string) => void,
) {
  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
    setNewName(e.currentTarget.value);

  const saveName = (newName: string) => {
    const trimmedNewName = newName.trim();
    if (!trimmedNewName || trimmedNewName === name) {
      setNewName(name);
    }
    onAction(name, trimmedNewName);
  };

  const onKeyUp = (
    e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
    newName: string,
  ) => {
    if (e.key === 'Enter') {
      saveName(newName);
    }
  };

  return {
    onChange,
    saveName,
    onKeyUp,
  };
}
